import gql from 'graphql-tag';

// A stop the driver could not complete: reason, when and who.
const COULD_NOT_COMPLETE_FRAGMENT = gql`
	fragment stopCouldNotComplete on ServiceDocket {
		couldNotComplete {
			reason
			at
			by {
				id
				firstname
				lastname
			}
		}
	}
`;

export default COULD_NOT_COMPLETE_FRAGMENT;
